export default __webpack_public_path__ + "static/media/mid-banner.d2d81a93.png";